import { render, staticRenderFns } from "./AcceptRequest.vue?vue&type=template&id=0b5f13f2"
import script from "./AcceptRequest.vue?vue&type=script&lang=ts"
export * from "./AcceptRequest.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports